<svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2298_8215)">
<rect x="4.7" y="3.7" width="28.6" height="22.6" rx="1.8" stroke="currentColor" stroke-width="1.4"/>
<path d="M26.3146 11.3644L21.6032 15.9609C21.259 16.2966 21.087 16.4645 20.8662 16.499C20.6454 16.5335 20.4303 16.4261 20.0001 16.2113L17.2248 14.8257C16.8107 14.6189 16.6036 14.5155 16.3894 14.5449C16.1751 14.5742 16.0035 14.7295 15.6602 15.04L11.6856 18.6356" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
</g>
<defs>
<clipPath id="clip0_2298_8215">
<rect width="38" height="30" fill="white"/>
</clipPath>
</defs>
</svg>
